import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PackageService {
  readonly name = 'website';
  readonly version = '3.13.0';
  readonly description = '';
  readonly displayName = 'Website';
}
